module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.question.statement))]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disabledAttribute
    },
    domProps: {
      "value": _vm.getBooleanAnswerValue()
    },
    on: {
      "change": _vm.onBooleanAnswerChange
    }
  }, [_c('option', {
    domProps: {
      "value": 'true'
    }
  }, [_vm._v("Sim")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'false'
    }
  }, [_vm._v("Não")])]), _vm._v(" "), (_vm.m_error) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.m_error))]) : _vm._e(), _vm._v(" "), (_vm.getBooleanAnswerValue()) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid box-primary"
  }, [_c('div', {
    staticClass: "box-body"
  }, _vm._l((_vm.question.fieldsWhenTrue), function(field) {
    return _c(_vm.getFieldComponent(field), {
      key: field.uuid,
      ref: "fields",
      refInFor: true,
      tag: "component",
      attrs: {
        "field": field,
        "fieldAnswer": _vm.getFieldAnswer(field),
        "isDisabled": _vm.disabledAttribute
      },
      on: {
        "fieldUpdated": _vm.onFieldUpdated
      }
    })
  }), 1)])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6932e1c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/quizzes/questions/BooleanFormQuestion.vue
// module id = 769
// module chunks = 1